import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setGuideBoardVisible } from 'store/actions';
import './GuideBoard.scss';
import handcursor from './handcursor.png';
import mouse from './mouse.png';

const GuideBoard = () => {
  const isVisible = useSelector((state) => state.guideBoardVisible);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setGuideBoardVisible(false));
  };

  if (!isVisible) return null;

  return (
    <div className="ntv-guide--board">
      <div className="ntv-guide--board--overlay" />
      <div className="ntv-guide--board--modal">
        <div className="ntv-guide--board--title">HƯỚNG DẪN THAO TÁC</div>

        <div className="ntv-guide--board--icons">
          <div className="ntv-guide--board--icon is-hand">
            <div className="ntv-guide--board--icon-glow" />
            <img src={handcursor} alt="hand gesture" />
          </div>

          <div className="ntv-guide--board--separator">hoặc</div>

          <div className="ntv-guide--board--icon is-mouse">
            <div className="ntv-guide--board--icon-glow" />
            <img src={mouse} alt="mouse" />
          </div>
        </div>

        <div className="ntv-guide--board--instruction">
          Chạm, di chuyển hoặc click vào từng vị trí tham quan để xem chi tiết
        </div>

        <button className="ntv-guide--board--button" onClick={handleClose}>
          Đã hiểu
        </button>
      </div>
    </div>
  );
};

export default GuideBoard;
